module.exports = __webpack_public_path__ + "media/images/logos/rd_r_logo-be19fd47ede395c29a032169ae9d53e1.png";